import React from "react";
import Navigation from "./Navigation";
import landingPic from "./pictures/IMG-20220824-WA0077.jpg";

import arrivalOne from "./pictures/IMG-20220824-WA0122.jpg";
import arrivalTwo from "./pictures/IMG-20220824-WA0071.jpg";
import arrivalThree from "./pictures/IMG-20220824-WA0087.jpg";
import arrivalFour from "./pictures/IMG-20220824-WA0077.jpg";
import wallet from "./pictures/noun-wardrobe-5037907.svg";
import diary from "./pictures/icons8-diary-80.png";
import chat from "./pictures/icons8-chat-32.png";

import style from "./pictures/icons8-clothes-32.png";
import Footer from "./Footer";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "./Home.css";
function Home() {
  console.log(landingPic);
  return (
    <div className="home-container">
      <div className="top">
        <Navigation></Navigation>
      </div>
      <div className="pic-container">
        <h1 className="header">
          Styclick is a fashion app that creates the experience of going or
          looking for tailors virtually.{" "}
        </h1>

        <img src={landingPic} alt="landing page main picture" id="landingPic" />
      </div>
      <div className="arrival">
        <div className="arrival-prompt">
          <h1>New Arrivals</h1>
          <div className="arrival-categories">
            <p>All</p>
            <p>Casual</p>
            <p>Native</p>
            <p>Material</p>
          </div>
        </div>
        <div className="product-arrivals">
          <div>
            <img src={arrivalOne} />
          </div>
          <div>
            <img src={arrivalTwo} />
          </div>
          <div>
            <img src={arrivalThree} />
          </div>
          <div>
            <img src={arrivalFour} />
          </div>
        </div>
        <div className="explore">
          <h2>Explore More</h2> <ArrowForwardIcon></ArrowForwardIcon>
        </div>
      </div>
      <div className="features">
        <div className="arrival-prompt">
          <h1>Styclick</h1>
          <h3 className="features-description">
            Styclick is a fashion app that connects fashion service providers
            e.g tailors, fabric sellers,delivery service providers with users
            who need their services. Basically, it creates the experience of
            going or looking for tailors virtually. Styclick is the digitization
            of the whole sewing process to make service delivery more efficient,
            faster, cheaper and easier.
          </h3>
          <div className="feature-specifics">
            <div>
              <h2>E Catalogue</h2>

              <img src={wallet} />
              <p>
                This feature is like an album/magazine or collection of pictures
                with styles from the tailors upload and other sources. Users can
                use this feature to browse for potential styles to get tailors
                to sew or use it as a template to create their own unique
                styles.
              </p>
            </div>
            <div>
              <h2>Offline Diary</h2>

              <img src={diary} />
              <p>
                This feature is like a pocket diary where the designer can input
                the details of the client. It is a digital version of the normal
                diary tailors use in writing down all clients details ,
                measurement and specifications as pertaining designs.This
                feature would be available both online and offline.
              </p>
            </div>{" "}
            <div>
              <h2>Chat</h2>

              <img src={chat} />
              <p>
                This platform makes it easier for the users and the fashion
                providers to have a one on one or group interaction. The feature
                would prevent and would not support the sending of phone nos,
                addresses and co.
              </p>
            </div>{" "}
            <div>
              <h2>Style It</h2>

              <img src={style} />
              <p>
                This is a creative and fun version of the app. With this
                feature, both designers and users can engage in trying to dress
                or style an avatar . you can customise various styles and
                designs for fun or to be implemented. You can play with
                colours,. Cuts, head gears,etc.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default Home;
